import { Box, Heading, Tag } from '@chakra-ui/react';
import useGetPortfolio from '@hooks/useGetPortfolio';
import { getPortfolioIdFromUrl } from '@utils/getUrlParams';

const Header = () => {
  const { portfolio } = useGetPortfolio({ portfolioId: getPortfolioIdFromUrl() });

  const onTagClose = () => {
    window.location.href = '/painel/campanhas';
  };

  return (
    <Box>
      <Heading>
        Campanhas
      </Heading>

      {portfolio && (
        <Tag.Root size="lg" mt={2} colorPalette="argos" variant="solid">
          <Tag.Label>{portfolio.name}</Tag.Label>
          <Tag.EndElement>
            <Tag.CloseTrigger onClick={onTagClose} cursor="pointer" />
          </Tag.EndElement>
        </Tag.Root>
      )}
    </Box>
  )
};

export default Header;
